import { useEffect, useState } from "react";
import { connect } from "react-redux";

const AppGuardia = ({ children, loginReducer }) => {
  const [hayCliente, setHayCliente] = useState(false);

  useEffect(() => {
    const { hayCliente } = loginReducer;
    setHayCliente(hayCliente);
  }, [loginReducer]);

  return children({ hayCliente });
};

const mapStateToProps = ({ loginReducer }) => {
  return { loginReducer };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(AppGuardia);
